export const ADMIN_ROLES = [
  "support_readonly",
  "operations_readonly",
  "security_readonly",
] as const;

export const ADMIN_PERMISSIONS = [
  "admin.overview.read",
  "admin.failed_flows.read",
  "admin.device_kpis.read",
  "admin.users.read",
  "admin.user_data.read",
  "admin.jobs.read",
  "admin.releases.read",
  "admin.security_summary.read",
] as const;

export type AdminRole = (typeof ADMIN_ROLES)[number];
export type AdminPermission = (typeof ADMIN_PERMISSIONS)[number];

const ROLE_PERMISSION_MAP: Record<AdminRole, readonly AdminPermission[]> = {
  support_readonly: [
    "admin.overview.read",
    "admin.failed_flows.read",
    "admin.device_kpis.read",
    "admin.users.read",
    "admin.user_data.read",
    "admin.jobs.read",
  ],
  operations_readonly: [
    "admin.overview.read",
    "admin.failed_flows.read",
    "admin.device_kpis.read",
    "admin.jobs.read",
    "admin.releases.read",
  ],
  security_readonly: [
    "admin.overview.read",
    "admin.failed_flows.read",
    "admin.device_kpis.read",
    "admin.jobs.read",
    "admin.releases.read",
    "admin.security_summary.read",
  ],
};

export function getAdminPermissionsForRoles(roles: AdminRole[]): AdminPermission[] {
  const permissions = new Set<AdminPermission>();

  for (const role of roles) {
    const mappedPermissions = ROLE_PERMISSION_MAP[role];

    for (const permission of mappedPermissions) {
      permissions.add(permission);
    }
  }

  return ADMIN_PERMISSIONS.filter((permission) => permissions.has(permission));
}

export function hasAdminPermission(
  permissions: AdminPermission[],
  permission: AdminPermission,
): boolean {
  return permissions.includes(permission);
}
